var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * ShareIos component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconShareIos extends BlocksElement {
    constructor() {
        super(...arguments);
        /**
         *
         * Append to the class name to pass classes (such as utility classes) into the internals
         */
        this.styleModifier = '';
    }
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon-share-ios', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.4723 8.75588C4.44626 8.75588 4.4213 8.76623 4.40292 8.78461C4.38454 8.80299 4.37414 8.828 4.37414 8.85404V21.4176C4.37414 21.4437 4.38449 21.4687 4.40298 21.4872C4.42146 21.5057 4.4463 21.5158 4.4723 21.5158H18.6064C18.6322 21.5158 18.6572 21.5056 18.6758 21.4872C18.6942 21.4686 18.7045 21.4435 18.7045 21.4176V8.85404C18.7045 8.82804 18.6942 8.80297 18.6757 8.78448C18.6572 8.76614 18.6323 8.75588 18.6064 8.75588H16.2506C15.8712 8.75588 15.5635 8.44827 15.5635 8.06881C15.5635 7.68935 15.8712 7.38174 16.2506 7.38174H18.6064C18.9968 7.38174 19.3713 7.53685 19.6474 7.81289C19.9232 8.0889 20.0786 8.46352 20.0786 8.85404V21.4176C20.0786 21.8081 19.9235 22.1825 19.6478 22.4585C19.3717 22.7342 18.9969 22.8899 18.6064 22.8899H4.4723C4.08178 22.8899 3.70739 22.7348 3.43139 22.4589C3.15535 22.1828 3 21.8081 3 21.4176V8.85404C3 8.46358 3.1551 8.0891 3.43121 7.813C3.43119 7.81301 3.43122 7.81298 3.43121 7.813M3.43121 7.813C3.70731 7.53689 4.08185 7.38174 4.4723 7.38174H6.82791C7.20737 7.38174 7.51498 7.68935 7.51498 8.06881C7.51498 8.44827 7.20737 8.75588 6.82791 8.75588H4.4723"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.5396 1.09985C11.9191 1.09985 12.2267 1.40747 12.2267 1.78693V15.921C12.2267 16.3004 11.9191 16.6081 11.5396 16.6081C11.1602 16.6081 10.8525 16.3004 10.8525 15.921V1.78693C10.8525 1.40747 11.1602 1.09985 11.5396 1.09985Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.0532 1.30119C11.3215 1.03287 11.7565 1.03287 12.0249 1.30119L15.1658 4.44209C15.4341 4.71041 15.4341 5.14544 15.1658 5.41376C14.8974 5.68208 14.4624 5.68208 14.1941 5.41376L11.539 2.75869L8.88396 5.41376C8.61564 5.68208 8.18061 5.68208 7.91229 5.41376C7.64397 5.14544 7.64397 4.71041 7.91229 4.44209L11.0532 1.30119Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property()
], BlocksIconShareIos.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconShareIos.prototype, "iconTitle", void 0);
__decorate([
    property()
], BlocksIconShareIos.prototype, "size", void 0);
__decorate([
    property()
], BlocksIconShareIos.prototype, "styleModifier", void 0);
if (customElements.get('cat-icon-share-ios') === undefined) {
    customElements.define('cat-icon-share-ios', BlocksIconShareIos);
}
